<template>
  <header>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="container-fluid">
        <a class="navbar-brand" href="#">Navbar</a>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <router-link class="nav-link" :to="{ name: 'Dashboard' }"
                >Home
              </router-link>
            </li>

            <li class="nav-item" v-show="isAdministrator">
              <router-link class="nav-link" :to="{ name: 'UserList' }"
                >Users
              </router-link>
            </li>

            <li class="nav-item" v-show="isUser">
              <router-link class="nav-link" :to="{ name: 'DataList' }"
                >Datas
              </router-link>
            </li>

            <li class="nav-item" v-show="isSuperAdministrator">
              <router-link class="nav-link" :to="{ name: 'ImportData' }"
                >Import Datas
              </router-link>
            </li>

            <li class="nav-item" v-show="isUser">
              <router-link class="nav-link" :to="{ name: 'ValueList' }"
                >Values
              </router-link>
            </li>

            <li class="nav-item" v-show="isSuperAdministrator">
              <router-link class="nav-link" :to="{ name: 'ImportValue' }"
                >Import Values
              </router-link>
            </li>
          </ul>
          <li class="d-flex">
            <span v-show="!isLoggedIn">
              <router-link class="btn btn-outline-success" to="/login"
                >Login</router-link
              >
            </span>

            <span v-show="isLoggedIn">
              <router-link class="btn" :to="{ name: 'CurrentUser' }">{{
                getLoggedInUserEmail
              }}</router-link>
            </span>

            <span v-show="isLoggedIn">
              <form class="d-flex" @submit="logout">
                <button class="btn btn-outline-danger" type="submit">
                  Logout
                </button>
              </form>
            </span>
          </li>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import { store } from "../store";

export default {
  data: () => {
    return {};
  },
  components: {},
  methods: {
    async logout(e) {
      e.preventDefault();

      let dispatchLogout = async () => {
        await store.dispatch("setUser", {});
        await store.dispatch("destroyTokens");
      };

      dispatchLogout().then(() => (window.location.href = "login"));
    },
  },
  computed: {
    ...mapGetters([
      "getLoggedInUserEmail",
      "isLoggedIn",
      "isSuperAdministrator",
      "isAdministrator",
      "isUser",
      "isSouthAfrica",
      "isKuwait",
      "isKenya",
    ]),
  },
};
</script>
